/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("internal_loads.title")}
      </Typography>
      <hr />

      {/* Sobre */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.about.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.about.body")}
        </Box>
      </Typography>

      {/* Medições */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.measurements.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.measurements.body")}
        </Box>
      </Typography>

      {/* Métricas */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.metrics.total_consumption.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.metrics.total_consumption.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.metrics.total_generation.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.metrics.total_generation.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.metrics.net_consumption.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.metrics.net_consumption.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.metrics.top_meter.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.metrics.top_meter.body")}
        </Box>
      </Typography>

      {/* Gráficos */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.charts.agg_net_cpes.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.charts.agg_net_cpes.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.charts.generation_by_meter.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.charts.generation_by_meter.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.charts.consumption_by_meter.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.charts.consumption_by_meter.body")}
        </Box>
      </Typography>

      <Typography variant="h3" mt={4} ml={2}>
        {t("internal_loads.charts.per_meter_net.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2} sx={{ whiteSpace: "pre-line" }}>
          {t("internal_loads.charts.per_meter_net.body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
